<template>
  <footer>
    <b-navbar fixed="bottom" type="dark" variant="primary">
      <div class="d-block mx-auto py-3">
        <div class="d-flex flex-align-center align-items-center justify-content-center">
          <a class="mr-2 ccdmd-logo" href="https://ccdmd.qc.ca" target="_blank">
            <img src="@/assets/img/logo-ccdmd_renv.png" />
          </a>
          <small class="d-inline-block text-center text-xs-left text-sm-left">© Centre collégial de développement de matériel didactique, Collège de Maisonneuve, {{ year }}.</small>
        </div>
      </div>
    </b-navbar>
  </footer>
</template>

<script>
/**
 * @file       Layout site footer component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "siteFooter",

  data () {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
  footer {
    small {
      color: rgba(255, 255, 255, 0.5);
    }

    @media only screen and (max-width: 991px) {
      .ccdmd-logo {
        display: inline-block;
      }
    }

    @media only screen and (min-width: 992px) {
      .ccdmd-logo {
        display: none;
      }
    }
  }
</style>
